<template>
  <div id="March2025" class="202503">
    <header class="fixed md:static top-0 left-0 w-full bg-white">
      <div class="flex items-center justify-between max-w-5xl mx-auto">
        <router-link :to="{ name: 'index' }" class="p-4 md:p-6 inline-block"><img src="~@/assets/images/202503/LIVEABC-LOGO.png" class="object-contain"></router-link>
        <div class="p-4 md:p-6 md:opacity-0" @click="isMenu = !isMenu"><img src="~@/assets/images/202503/MENU.png" class="object-contain"></div>
      </div>
      <div v-if="isMenu">
        <ul>
          <li><a class="menu-bg block text-white p-2 text-center border-b border-black cursor-pointer" @click="toTop('#plan1')">雜誌方案</a></li>
          <li><a class="menu-bg block text-white p-2 text-center cursor-pointer" @click="toTop('#plan2')">叢書方案</a></li>
        </ul>
      </div>
    </header>
    <div class="web-menu fixed right-0 hidden md:block">
      <ul>
        <li>
          <a class="">
            <img src="~@/assets/images/202503/menu/MENU-OFF_01.png" class="object-contain">
          </a>
        </li>
        <li>
          <a class="hover-item cursor-pointer" @click="toTop('#plan1')">
            <img src="~@/assets/images/202503/menu/MENU-OFF_02.png" class="object-contain off">
            <img src="~@/assets/images/202503/menu/MENU-ON_02.png" class="object-contain on">
          </a>
        </li>
        <li>
          <a class="hover-item cursor-pointer" @click="toTop('#plan2')">
            <img src="~@/assets/images/202503/menu/MENU-OFF_03.png" class="object-contain off">
            <img src="~@/assets/images/202503/menu/MENU-ON_03.png" class="object-contain on">
          </a>
        </li>
        <li>
          <a class="hover-item cursor-pointer" @click="toTop('#March2025')">
            <img src="~@/assets/images/202503/menu/MENU-OFF_04.png" class="object-contain off">
            <img src="~@/assets/images/202503/menu/MENU-ON_04.png" class="object-contain on">
          </a>
        </li>
      </ul>
    </div>
    <div class="main">
      <div class="mx-auto top-line">
        <!-- <img src="~@/assets/images/202503/line_up.png" class="object-contain mx-auto hidden md:block">
        <img src="~@/assets/images/202503/m/line_up.png" class="object-contain mx-auto md:hidden transform rotate-180 "> -->
      </div>
      <div class="top">
        <div class="mx-auto mb-6 max-w-5xl">
          <img src="~@/assets/images/202503/master-photo.png" class="object-contain mx-auto hidden md:block">
          <img src="~@/assets/images/202503/m/master-photo-mobile.png" class="object-contain mx-auto md:hidden">
        </div>

        <div class="flex flex-wrap md:flex-no-wrap justify-center mb-6 max-w-5xl mx-auto">
          <div class="w-full md:w-auto flex justify-center p-1">
            <img src="~@/assets/images/202503/old/plan-01.png" class="object-contain hidden md:block mx-auto">
            <img src="~@/assets/images/202503/old/plan-01-mobile.png" class="object-contain mx-auto md:hidden">
          </div>
          <div class="w-1/2 md:w-auto p-1 cursor-pointer" @click="toTop('#plan1')">
            <img src="~@/assets/images/202503/old/plan-02.png" class="object-contain mx-auto">
            <!-- <img src="~@/assets/images/202503/m/plan-02-mobile.png" class="object-contain mx-auto md:hidden"> -->
          </div>
          <div class="w-1/2 md:w-auto p-1 cursor-pointer" @click="toTop('#plan2')">
            <img src="~@/assets/images/202503/old/plan-03.png" class="object-contain mx-auto">
            <!-- <img src="~@/assets/images/202503/m/plan-03-mobile.png" class="object-contain mx-auto md:hidden"> -->
          </div>
        </div>
      </div>

      <a href="https://store.liveabc.com/products/recent/sale?tag=472" target="_blank" class="plan1 block" id="plan1">
        <div class="max-w-5xl mx-auto">
          <div class="mx-auto max-w-5xl">
            <img src="~@/assets/images/202503/MG-tittle-01.png" class="object-contain mx-auto hidden md:block">
            <img src="~@/assets/images/202503/m/MG-TITLE-01-MOBILE.png" class="object-contain mx-auto md:hidden">
          </div>
        </div>
        <div class="mx-auto py-12 plan1_inner">
          <img src="~@/assets/images/202503/PART-B.png" class="object-contain mx-auto max-w-5xl hidden md:block">
          <img src="~@/assets/images/202503/m/PART-B-mobile.png" class="object-contain mx-auto max-w-5xl md:hidden">
        </div>
      </a>

      <div class="plan2" id="plan2">
        <a class="mx-auto max-w-5xl block" href="https://store.liveabc.com/products/recent/sale?tag=473" target="_blank">
          <img src="~@/assets/images/202503/BOOK-TITLE-01.png" class="object-contain mx-auto max-w-5xl hidden md:block">
          <img src="~@/assets/images/202503/m/BOOK-TITLE-01-MOBILE.png" class="object-contain mx-auto max-w-5xl md:hidden">
        </a>
        <a class="mx-auto pt-12 block" href="https://store.liveabc.com/products/recent/sale?tag=473" target="_blank">
          <img src="~@/assets/images/202503/rule-01.png" class="object-contain mx-auto max-w-5xl hidden md:block">
          <img src="~@/assets/images/202503/m/rule-01-mobile.png" class="object-contain mx-auto max-w-5xl md:hidden">
        </a>
        <div class="plan2_inner w-full">
          <div class="flex flex-wrap max-w-3xl mx-auto py-12">
            <router-link target="_blank" :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="w-1/2 md:w-1/4 p-3" v-for="(item, index) in bookData" :key="index">
              <img :src="item.img_url" class="object-contain block mx-auto">
            </router-link>
            <div class="w-1/2 md:w-1/4 p-2 flex items-end"><img src="~@/assets/images/202503/images-03.png" class="object-contain block -mb-4 md:-mb-8"></div>
          </div>
        </div>
        <div class="z-0 bottom-line">
          <!-- <img src="~@/assets/images/202503/line_up.png" class="object-contain mx-auto transform rotate-180 origin-center z-0 hidden md:block">
          <img src="~@/assets/images/202503/m/line_up.png" class="object-contain mx-auto transform rotate-180 origin-center z-0 md:hidden"> -->
        </div>
      </div>
      <footer class="bg-white py-6 pb-10 z-20">
        <router-link :to="{ name: 'index' }" class="mx-auto mb-4 z-20"><img src="~@/assets/images/202503/go-to-liveabc.png" class="object-contain mx-auto max-w-5xl z-20"></router-link>
        <p class="text-center font-semibold mb-2">注意事項</p>
        <p class="text-center font-semibold">‧活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</p>
      </footer>
    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'October2024',
  metaInfo () {
    return {
      title: '訂雜誌就送點讀筆！LiveABC生活語言書展 任選3本好書$888',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      bookData: [
        { id: 8142, img_url: require('@/assets/images/202503/book-01.png') },
        { id: 10528, img_url: require('@/assets/images/202503/book-02.png') },
        { id: 8464, img_url: require('@/assets/images/202503/book-03.png') },
        { id: 9440, img_url: require('@/assets/images/202503/book-04.png') },
        { id: 7287, img_url: require('@/assets/images/202503/book-05.png') },
        { id: 7231, img_url: require('@/assets/images/202503/book-06.png') },
        { id: 6190, img_url: require('@/assets/images/202503/book-07.png') },
        { id: 9958, img_url: require('@/assets/images/202503/book-08.png') },
        { id: 10274, img_url: require('@/assets/images/202503/book-09.png') },
        { id: 8465, img_url: require('@/assets/images/202503/book-10.png') },
        { id: 7219, img_url: require('@/assets/images/202503/book-11.png') },
        { id: 7496, img_url: require('@/assets/images/202503/book-12.png') },
        { id: 8926, img_url: require('@/assets/images/202503/book-13.png') },
        { id: 6032, img_url: require('@/assets/images/202503/book-14.png') },
        { id: 7801, img_url: require('@/assets/images/202503/book-15.png') }
      ]
    }
  },
  mounted () {
  },
  methods: {
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#March2025 {
.top-line {
  width: 100%;
  height: 49px;
  background-image: url('~@/assets/images/202503/line_up.png');
  background-repeat: repeat-x;
  background-size: contain;
  background-position: center;
  @media (max-width: 767px) {
    background-size: cover;
  }
}
.bottom-line {
  width: 100%;
  height: 49px;
  background-image: url('~@/assets/images/202503/line_up.png');
  background-repeat: repeat-x;
  background-size: contain;
  background-position: center;
  transform: rotate(180deg);
  @media (max-width: 767px) {
    background-size: cover;
  }
}
.menu-bg {
  background-color: #002A32F2;
}
.web-menu {
  top: 10%;
}
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .toggle-btn {
    top: 20%;
    left: -50%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    left: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    left: -174px;
    transition: 0.3s;
  }
  .main {
    background-color: #FE6D48;
    @media (max-width: 767px) {
      padding-top: 56px;
    }
    .top {
      background-image: url('~@/assets/images/202503/cloud1.png');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center bottom;
    }
  }
}
.plan1_inner {
  // background-image: url('~@/assets/images/202503/cloud1.png');
  // background-repeat: no-repeat;
  // background-size: contain;
  // background-position: center bottom;
  // transform: scaleX(-1);
  position: relative;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url('~@/assets/images/202503/cloud1.png');
      background-size: contain;
      background-position: center bottom;
      transform: scaleX(-1);
      background-repeat: no-repeat;
    }
}
.plan2_inner {
  background-image: url('~@/assets/images/202503/BG-Eiffel.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center bottom;
}
</style>
